import React, { useEffect, useState } from "react";
import googleLogo from "assets/images/google_logo.png";
import AuthDialogLayout from "components/Layout/AuthDialogLayout";
import { ReactComponent as EyeOff } from "assets/icons/eye_off.svg";
import { ReactComponent as EyeOpen } from "assets/icons/eye_open.svg";
import useDialog from "hooks/useDialog";
import useAuth from "hooks/useAuth";

const SignInDialog = () => {
  const {
    isSigninDialogOpen,
    closeSigninDialog,
    openSignupDialog,
    openForgotPasswordDialog,
    openVerifyEmailDialog,
  } = useDialog();

  const { signIn, loading, error, signInWithGoogle } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(true);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const user = await signIn(email.trim(), password.trim());
      closeSigninDialog();
      if (!user.emailVerified) {
        openVerifyEmailDialog(user?.firstName, user?.lastName, email);
      }
    } catch (err) {
      console.log(err);
    }

    // Save local storage
    if (rememberMe) {
      localStorage.setItem("userInfo", JSON.stringify({ email, password }));
    } else {
      localStorage.removeItem("userInfo");
    }
  };

  const handleGoogleLogin = async () => {
    try {
      await signInWithGoogle();
      closeSigninDialog();
    } catch (err) {
      console.error("Google login error", err);
    }
  };

  useEffect(() => {
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
      const { email, password } = JSON.parse(userInfo);
      setEmail(email);
      setPassword(password);
      setRememberMe(true);
    }
  }, []);

  if (!isSigninDialogOpen) {
    return null;
  }
  return (
    <AuthDialogLayout
      isDialogOpen={isSigninDialogOpen}
      closeDialog={closeSigninDialog}
    >
      <form
        onSubmit={handleSubmit}
        className="2xl:mt-[101px] md:mt-5 lg:mt-[80px]"
      >
        <h2 className="text-[20px] font-semibold leading-[28px] text-[#1A1A1A]">
          Bentornato!
        </h2>
        <div className="mt-4 md:mt-[24px]">
          <label className="text-[11px] font-normal text-[#333333] md:pl-4">
            Email
          </label>
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="auth-input"
          />
        </div>
        <div className="mt-[6px] md:mt-4 relative">
          <label className="text-[11px] font-normal text-[#333333] md:pl-4">
            Password
          </label>
          <input
            value={password}
            type={showPassword ? "text" : "password"}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="auth-input"
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
          />
          <div
            onClick={() => setShowPassword((show) => !show)}
            className="absolute bottom-[2px] md:bottom-2 right-2 cursor-pointer w-[32px] h-[32px] flex items-center justify-center"
          >
            {showPassword ? (
              <EyeOpen width={16} height={16} />
            ) : (
              <EyeOff width={18} height={18} />
            )}
          </div>
        </div>
        <div className="h-5 w-full flex items-center justify-between mt-4 md:mt-5">
          <div className="flex items-center space-x-2">
            <div>
              <input
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                type="checkbox"
                name="switch"
                id="switch_remember_me"
                className="checkbox_input hidden"
              />
              <label
                className="checkbox_label"
                htmlFor="switch_remember_me"
              ></label>
            </div>

            <p className="text-[#1A1A1A] text-[12px] font-normal leading-5 tracking-[0.3px]">
              Ricordami
            </p>
          </div>
          <p
            onClick={openForgotPasswordDialog}
            className="text-[#007AFF] text-[12px] cursor-pointer font-normal leading-5 tracking-[0.3px]"
          >
            Password dimenticata?
          </p>
        </div>
        {error && (
          <div className="mt-4 lg:mt-[24px] ">
            <p className="text-[#F61D1D] text-center text-[15px] font-normal line-clamp-2">
              {error}
            </p>
          </div>
        )}
        <button type="submit" disabled={loading} className="auth-btn">
          Accedi
        </button>
        <hr className="bg-[#E5E5E5] h-[0.5px] w-full" />
        <div
          onClick={handleGoogleLogin}
          className="bg-[#333333] cursor-pointer h-[40px] hover:bg-opacity-80 transition-all duration-300 ease-in-out w-full mt-[22px]  md:mt-[32px] rounded-[6px] flex items-center justify-center space-x-2"
        >
          <img src={googleLogo} alt="logo" className="w-5 h-5" />
          <p className="text-[12px] font-normal leading-5 tracking-[0.3px] text-white">
            Accedi tramite Google
          </p>
        </div>
        <div className="mt-5 md:mt-[24px] flex items-center space-x-2 justify-center">
          <p className="text-[12px] font-normal leading-5 tracking-[0.3px] text-[#1A1A1A]">
            Non hai un account?
          </p>
          <p
            onClick={openSignupDialog}
            className="cursor-pointer text-[12px] font-normal leading-5 tracking-[0.3px] text-primary"
          >
            Iscriviti Ora!
          </p>
        </div>
      </form>
    </AuthDialogLayout>
  );
};

export default SignInDialog;
